module.exports = __webpack_public_path__ + "img/generate_code.9da711b0.gif";